import React, { useState, useEffect } from 'react';
import { Wrapper, Input, Track, Button } from './style.js';

function Switch(_a) {
    var name = _a.name, value = _a.value, _b = _a.size, size = _b === void 0 ? 'medium' : _b, checked = _a.checked, _c = _a.disabled, disabled = _c === void 0 ? false : _c, onChange = _a.onChange;
    var _d = useState(checked), isChecked = _d[0], setIsChecked = _d[1];
    useEffect(function () {
        setIsChecked(checked);
    }, [checked]);
    var handleChange = function () {
        if (disabled) {
            return;
        }
        setIsChecked(!isChecked);
        if (onChange)
            onChange();
    };
    return (React.createElement(Wrapper, null,
        React.createElement(Input, { type: "checkbox", name: name, value: value, checked: isChecked, onChange: function () { }, "data-testid": "switch-wrapper" }),
        React.createElement(Track, { size: size, checked: isChecked, disabled: disabled, onClick: handleChange, "data-testid": "switch-track" },
            React.createElement(Button, { size: size, checked: isChecked }))));
}

export { Switch as default };
